const actions = {
  SET_STATE: 'learners/SET_STATE',
  GET_DATA: 'learners/GET_DATA',
  EDIT_LEARNER: 'learners/EDIT_LEARNER',
  CREATE_LEARNER: 'learners/CREATE_LEARNER',
  UPDATE_LERNERS_LIST: 'learners/UPDATE_LERNERS_LIST',
  APPEND_LERNERS_LIST: 'learners/APPEND_LERNERS_LIST',
  GET_LEARNERS_DROPDOWNS: 'learners/GET_LEARNERS_DROPDOWNS',
  LEARNER_ACTIVE_INACTIVE: 'learners/LEARNER_ACTIVE_INACTIVE',
  UPDATE_LEARNER_ACTIVE_INACTIVE: 'learners/UPDATE_LEARNER_ACTIVE_INACTIVE',

  GET_LEARNERS: 'learners/GET_LEARNERS',
  PAGE_CHANGED: 'learners/PAGE_CHANGED',
  ROWS_CHANGED: 'learners/ROWS_CHANGED',
  GET_SINGLE_LEARNER: 'learners/GET_SINGLE_LEARNER',
  EDIT_GENERAL_INFO: 'learners/EDIT_GENERAL_INFO',

  GET_LEARNER_ATTENDANCE_REPORT: 'learners/GET_LEARNER_ATTENDANCE_REPORT',
}

export default actions
